import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import pickUpOrder from '../../../../assets/img/pickup-order.png';

function PickupFlowIllustration() {
  const { t } = useTranslation('description', {
    keyPrefix: 'orders.deliver.pickup_type11',
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 280,
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: '#fff',
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={pickUpOrder}
          alt=""
          sx={{
            width: '100%',
            height: 'auto',
            display: 'block',
          }}
        />
      </Box>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          textAlign: 'center',
          px: 1,
          color: 'text.primary',
          lineHeight: 1.45,
        }}
      >
        {t('thanks_illustration')}
      </Typography>
    </Box>
  );
}

export default PickupFlowIllustration;
